module.exports = __webpack_public_path__ + "img/num_12.83a9ad11.png";